<app-navigation-header [title]="navigationHeaderTitle | translate"></app-navigation-header>
<router-outlet></router-outlet>
